<template>
  <div class="sala-aula-curso-expirado">
    <div>
      <p>Curso Expirado</p>
      <p>O acesso a esse curso acabou, esperamos que tenha aproveitado e obtido conhecimento com ele.</p>
    </div>
    <div>
      <img :src="require('@/assets/img/cursoExpirado.png')">
    </div>
    <div>
      <p></p>
      <p>Acesse <strong><a href="https://www.artmed360.com.br" target="_blank">artmed360.com.br</a></strong> para ver mais de nossos cursos</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopicoCursoExpirado'
}
</script>
